import React, { PropsWithChildren } from 'react';

import QuoteImage, { WIDTH as QUOTE_IMAGE_WIDTH } from '../components/QuoteImage';
import Footer from 'components/Footer/Footer';
import styled from 'styled-components';

// TODO: Remove this wrapper when all layouts will have the same structure
const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  height: 100%;

  main,
  footer {
    @media ${({ theme }) => theme.queries.minLargeDesktop} {
      margin-left: ${QUOTE_IMAGE_WIDTH};
    }
  }

  main {
    margin-bottom: 95px;
  }
`;

const Content = styled.main`
  margin-top: 2em;
`;

const QuoteImageWrapper = styled.div`
  display: none;

  @media ${({ theme }) => theme.queries.minLargeDesktop} {
    display: block;
  }
`;

const SSOLoginLayout: React.FC<PropsWithChildren> = ({ children }) => (
  <Wrapper>
    <QuoteImageWrapper>
      <QuoteImage />
    </QuoteImageWrapper>

    <Content>{children}</Content>
    <Footer />
  </Wrapper>
);

export default SSOLoginLayout;
